import React from 'react';

import StatusBadge from './StatusBadge';
import PropTypes from 'prop-types';
import { isCB, isYB, isVMBusiness } from '../../utils/BrandUtils';

const CustomComponentActive = ({ rowData, data, metadata, customClick }) => {
  const viewClick = () => {
    customClick(this.props.rowData);
  };
  const renderCell = () => {
    switch (metadata.columnName) {
      case 'status':
        return <StatusBadge status={rowData.status} />;
      case 'fromAccountName':
        if (isCB() || isYB() || isVMBusiness())
          return (
            <span>{`${
              rowData.fromAccountName ||
              rowData.fromAccountSortCode +
                ' ' +
                rowData.fromAccountAccountNumber
            }`}</span>
          );
        return (
          <span>{`${rowData.fromAccountSortCode} ${rowData.fromAccountAccountNumber}`}</span>
        );
      case 'toAccountName':
        return (
          <span>
            {rowData.toAccountName
              ? rowData.toAccountName
              : `${rowData.toAccountSortCode} ${rowData.toAccountAccountNumber}`}
          </span>
        );
      default:
        return (
          <div className="custom-column" onClick={viewClick}>
            {data}
          </div>
        );
    }
  };
  return renderCell();
};

CustomComponentActive.propTypes = {
  rowData: PropTypes.object,
  data: PropTypes.object,
  metadata: PropTypes.object,
  customClick: PropTypes.func,
};

export default CustomComponentActive;
